import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextSubHeading, TextCaption2, Button, Icon } from 'blocket-ui'
import { mediaQueries } from '@blazar-plugins/device'
import visuallyHidden from 'utils/visuallyHidden'
import BostadRentIllustration from './BostadRentIllustration'
import arrowRightIcon from './arrow_right.svg'

const Wrapper = styled.div`
  background-color: #f0f5fb;
  position: relative;
  display: flex;
  padding: 16px;
  margin-top: 8px;
  align-items: center;

  @media ${mediaQueries.medium} {
    padding: 32px;
    margin-top: 16px;
    border: 1px solid #dfdede;
  }
`

const RightWrapper = styled.div`
  display: flex;
  flex-grow: 1;

  @media ${mediaQueries.medium} {
    width: auto;
  }
`

const LeftWrapper = styled.div`
  margin-right: 16px;

  @media ${mediaQueries.medium} {
    margin-right: 32px;
  }
`

const TextWrapper = styled.div`
  margin-right: 16px;
`

const LinkWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;

  a::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .rental-link-small {
    height: 16px;
    width: 10px;
  }

  .rental-link-medium {
    display: none;
  }

  @media ${mediaQueries.medium} {
    .rental-link-small {
      display: none;
    }
    .rental-link-medium {
      display: inline-block;
    }
  }
`

const Heading = styled(TextSubHeading)`
  color: #363433;
  font-size: 15px;

  @media ${mediaQueries.medium} {
    font-family: 'BlocketSans-Bold', sans-serif;
    font-size: 24px;
    margin-bottom: 8px;
  }
`

const Description = styled(TextCaption2)`
  color: #696766;
  font-size: 12px;
  line-height: 16px;

  @media ${mediaQueries.medium} {
    font-size: 15px;
    line-height: 20px;
  }
`

const RENT_LINK =
  'https://bostad.blocket.se/hitta-bostad/?utm_source=blocket&utm_medium=web&utm_campaign=listing_bbq_banner&utm_content=letar_du_boende'
const RENT_TEXT = 'Visa uthyresannonser'

const BostadRentLink = ({ cg }) => {
  // Render on all bostad except utland (because qasa doesn't have utland)
  if (!cg || cg[0] !== '3' || cg === '3080') {
    return null
  }

  return (
    <Wrapper>
      <LeftWrapper>
        <BostadRentIllustration />
      </LeftWrapper>
      <RightWrapper>
        <TextWrapper>
          <Heading tagName="h2">Letar du boende att hyra?</Heading>
          <Description tagName="p">
            Andrahandskontrakt, förstahandskontrakt och trygg uthyrning på samma plats.
          </Description>
        </TextWrapper>
        <LinkWrapper>
          <a className="rental-link-small" href={RENT_LINK}>
            <Icon icon={arrowRightIcon} width={10} height={17} />
            <span style={visuallyHidden}>{RENT_TEXT}</span>
          </a>
          <Button className="rental-link-medium" type="secondary" href={RENT_LINK}>
            {RENT_TEXT}
          </Button>
        </LinkWrapper>
      </RightWrapper>
    </Wrapper>
  )
}

BostadRentLink.propTypes = {
  cg: PropTypes.string,
}

export default BostadRentLink
